<!--接口日志-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList">
        <a-select slot="interfaceType" v-model="queryParams.interfaceType" allowClear>
          <a-select-option v-for="(item) in typeList" :key="item.key">{{ item.label }}</a-select-option>
        </a-select>
        <a-select slot="status" v-model="queryParams.status" allowClear>
          <a-select-option v-for="(item) in statusList" :key="item.key">{{ item.label }}</a-select-option>
        </a-select>
        <a-range-picker slot="createTime" v-model="currentCreateTimeObj" @change="changePriceRangeDate" />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" v-hasPermi="['external:externalInterfaceCallRecord:rePush']" @click="handleRePush">接口重传</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['external:interface:updateStatus']" @click="handleUpdate">更新状态</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['mq-fpl:mdj:pushWorkOrderList']" @click="handlePushOrder">重推工单</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          class="interface-log"
          ref="interfaceLogTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @successCallBack="successCallBack"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1200 }"
        >
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
        <a-modal v-model="modal" title="确认" width="450px" :maskClosable="false" :closable="false">
          <a-form-model :model="formData" ref="form">
            <a-form-model-item
              label="单号"
              :labelCol="{ style: 'width: 70px;float:left' }"
              :wrapperCol="{ style:'width:calc(100% - 70px ) !important;float:left'}"
              prop="wipEntityNameVal"
              :rules="rules.wipEntityNameVal"
            >
              <a-input v-model="formData.wipEntityNameVal" placeholder="多单号空格分隔" />
            </a-form-model-item>
          </a-form-model>
          <template #footer>
            <a-space>
              <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
              <a-button type="primary" @click="submit" :loading="modalLoading">确定</a-button>
            </a-space>
          </template>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, handleCopyFromExcel } from '@/utils/util.js'
import moment from 'moment'
import { interfaceLogList, pushWorkOrderListApi, rePush, updateStatusApi } from '@/api/system/interfaceLog'

export default {
  name: 'InterfaceLog',
  data () {
    return {
      currentCreateTimeObj: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formData: { wipEntityNameVal: '', wipEntityNameList: [] },
      loading: false,
      modalLoading: false,
      modal: false,
      rules: {
        wipEntityNameVal: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(interfaceLogList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        businessCodeVal: undefined,
        createName: undefined,
        interfaceType: undefined,
        status: undefined,
        createTime: undefined,
        startCreateTime: undefined,
        endCreateTime: undefined
      },
      statusList: [{ key: 1, label: '成功' }, { key: 0, label: '失败' }],
      typeList: [{ key: 1, label: '生产领料同步' }, { key: 2, label: '生产完工入库同步' }, { key: 3, label: '跨组织调拨' }, { key: 4, label: '推送scm价格材料池' }, { key: 5, label: '生产领料同步-CC' }, { key: 6, label: '推送变更bom' }, { key: 7, label: '工单数量变更' }],
      // 表格数据
      tableList: [],
      formList: [
        { label: '单号', decorator: ['businessCodeVal'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '操作人员', decorator: ['createName'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '类型', decorator: ['interfaceType'], type: 'interfaceType' },
        { label: '状态', decorator: ['status'], type: 'status' },
        { label: '操作时间', decorator: ['createTime'], type: 'createTime' }
      ],
      // 表格字段
      columns: [
        {
          title: '接口类型',
          dataIndex: 'interfaceType',
          align: 'center',
          width: 100,
          customRender: (text, record) => (this.typeList.find(v => v?.key === record.interfaceType)?.label)
        },
        { title: '业务单号', dataIndex: 'businessCode', align: 'center', width: 140 },
        {
          title: '接口状态',
          dataIndex: 'status',
          align: 'center',
          width: 80,
          customRender: (text, record) => (this.statusList.find(v => v?.key === record.status)?.label)
        },
        { title: '接口传送时间', dataIndex: 'sendTime', align: 'center', width: 140, scopedSlots: { customRender: 'dateFormat' } },
        { title: '错误信息', dataIndex: 'errorMessage', align: 'center', width: 250 },
        { title: '错误代码', dataIndex: 'errorCode', align: 'center', width: 100 },
        { title: '请求方法', dataIndex: 'requestMethod', align: 'center', width: 90 },
        { title: '重传次数', dataIndex: 'resendCount', align: 'center', width: 90 },
        { title: '请求url', dataIndex: 'requestUrl', align: 'center', width: 200 },
        { title: '请求参数', dataIndex: 'requestParam', align: 'center', width: 300 },
        { title: '请求耗时', dataIndex: 'timeConsuming', align: 'center', width: 100 },
        { title: '返回信息', dataIndex: 'reponseMessage', align: 'center', width: 300 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 130 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 90 }
      ]
    }
  },
  created () {},
  mounted () {
    this.loading = false;
    this.queryParams.startCreateTime = moment().subtract(6, 'days').format('YYYY-MM-DD 00:00:00')
    this.queryParams.endCreateTime = moment().format('YYYY-MM-DD 23:59:59')
    this.currentCreateTimeObj = [moment().subtract(6, 'days'), moment()]
    this.onSearch()
  },
  methods: {
    // 更新状态
    handleUpdate() {
      if (this.selectedRowKeys?.length > 0) {
        this.loading = true;
        updateStatusApi(this.selectedRowKeys).then(res => {
          if (res?.code === 200) {
            this.$message.success('更新成功')
            this.onSearch(this.$refs?.interfaceLogTable?.searchParams)
          } else {
            this.$message.error(res?.msg)
          }
        }).finally(e => {
          this.loading = false;
        })
      } else {
        this.$message.warning('请选择要更新状态的日志')
      }
    },
    // 确认提交
    submit() {
      this.$refs.form.validate(valid => {
        if(valid) {
          handleCopyFromExcel('wipEntityName', 'wipEntityNameList', this.formData) // 物料编码支持excel的copy查询
          this.modalLoading = true;
          const wipEntityNameList = this.formData?.wipEntityNameList?.length > 0 ? this.formData.wipEntityNameList : [this.formData?.wipEntityNameVal]
          pushWorkOrderListApi(wipEntityNameList).then(res => {
            if (res?.code === 200) {
              this.$message.success('操作成功')
              this.modal = false;
              this.onSearch(this.$refs?.interfaceLogTable?.searchParams)
            } else {
              this.$message.error(res?.msg)
            }
          }).finally(e => {
            this.modalLoading = false;
          })
        }
      })
    },
    // 重推工单
    handlePushOrder() {
      this.formData = { wipEntityNameVal: '', wipEntityNameList: [] }
      this.modal = true;
    },
    // 翻页清除选择
    successCallBack() {
      if (this.$refs?.interfaceLogTable) this.$refs.interfaceLogTable.onClear(); // 清除选择
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 选择时间
    changePriceRangeDate (dateArr, dateStrArr) {
      if (dateStrArr?.length > 0 && dateStrArr[0]) {
        this.queryParams.startCreateTime = dateStrArr[0] + ' 00:00:00'
        this.queryParams.endCreateTime = dateStrArr[1] + ' 23:59:59'
      } else {
        this.queryParams.startCreateTime = undefined
        this.queryParams.endCreateTime = undefined
      }
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      handleCopyFromExcel('businessCode', 'businessCodeList', params)
      this.$refs.interfaceLogTable.searchParams = params;
      this.$refs.interfaceLogTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        businessCodeVal: undefined,
        createName: undefined,
        interfaceType: undefined,
        status: undefined,
        createTime: undefined,
        startCreateTime: undefined,
        endCreateTime: undefined
      }
      this.currentCreateTimeObj = [];
    },
    // 日志重推
    handleRePush () {
      if (this.selectedRowKeys?.length > 0) {
        this.loading = true;
        rePush(this.selectedRowKeys).then(res => {
          if (res?.code === 200) {
            this.$message.success('重传成功')
            this.onSearch(this.$refs?.interfaceLogTable?.searchParams)
          } else {
            this.$message.error(res?.msg)
          }
        }).finally(e => {
          this.loading = false;
        })
      } else {
        this.$message.warning('请选择要重传的日志')
      }
    }
  }
}
</script>

<style scoped lang="less">
.interface-log {
  /deep/ .ant-table-tbody tr td {
    padding: 8px 8px;
  }
  /deep/ .ant-table-thead > tr > th {
    padding: 12px 8px;
  }
}
</style>
